// CSS  

//Lib
import { mapState } from "vuex";

// Event, Dialog 

// Api
import api from '@/api/baseApi';

// Constant 
import { HOST_URL } from "@/constant/routeApi";
import { TRANSACTION_STATUS, PAYMENT_METHOD_ID } from "@/constant/payment";
import { SETTINGS_TRANSACTION_API } from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import basePaymentService from '@/scripts/payment/basePaymentService';

// Components 
import Invoice from "@/views/component/Billing/Invoice.vue";

import CaretTop from "@/views/component/Icon/CaretTop.vue";
import CaretBottom from "@/views/component/Icon/CaretBottom.vue";
import RechargeTableView from "@/views/Payment/RechargeViews/TableView.vue";
import RechargeBlockView from "@/views/Payment/RechargeViews/BlockView.vue";

// Function 
const queryString = require('query-string');

export default {
    components: {
        Invoice,
        CaretTop,
        CaretBottom,
        RechargeTableView,
        RechargeBlockView,
    },

    extends: basePaymentService,

    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },

    data() {
        return {
            pagination: {
                status: 1,
                orderBy: 3,
                type: 1,
                directionSort: 'DESC',
                pageIndex: 1,
                pageSize: 20,
                outRowsNumber: 0,
            },
            listData: [],
        }
    },

    computed: {

    },

    created() {
        this.getData();
    },

    mounted() {

    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Action
        action(param) {
            let action = this.$action;
            switch (param) {
                case action.CLICK_REFRESH_FIXED_RENTAL_VIEW:
                    this.getData();
                    break;
            }
        },
        //#endregion

        // Sort list
        sortList(element) {
            this.pagination.pageIndex = 1;
            this.pagination.orderBy = element;
            if (this.pagination.directionSort === 'ASC') {
                this.pagination.directionSort = 'DESC'
            } else {
                this.pagination.directionSort = 'ASC'
            }
            this.getData();
        },

        // Pagination size change
        handleSizeChange(pageSize) {
            this.pagination.pageIndex = 1;
            this.pagination.pageSize = pageSize;
            this.getData();
        },

        // Pagination page change
        handleCurrentChange(element) {
            this.pagination.pageIndex = element;
            this.getData();
        },

        //#region Get data
        getData() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            api.baseRequest(SETTINGS_TRANSACTION_API.TRANSACTION_RECHARGE_HISTORY_VIEW, null, `?${queryString.stringify(this.pagination)}`)
                .then((res) => {
                    let responseData = res.data;
                    let pagingItem = responseData.pagingItem;
                    this.listData = responseData.data;
                    this.pagination.orderBy = pagingItem.orderBy;
                    this.pagination.directionSort = pagingItem.directionSort;
                    this.pagination.pageIndex = pagingItem.pageIndex;
                    this.pagination.pageSize = pagingItem.pageSize;
                    this.pagination.outRowsNumber = pagingItem.outRowsNumber;
                    this.processingPaymentUrl();
                    this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.listData);
                })
                .catch(error => {
                    this.processCatchApiRequest(error, this.$t('payment.rechargeHistoryViewFailed'))
                });
        },
        //#endregion  

        //#region Processing payment url
        processingPaymentUrl() {
            this.listData.forEach(element => {
                if (element.status === TRANSACTION_STATUS.PAYING) {
                    switch (element.paymentMethodId) {
                        case PAYMENT_METHOD_ID.PAYPAL:
                        case PAYMENT_METHOD_ID.NGANLUONG:
                        case PAYMENT_METHOD_ID.MOMO:
                        case PAYMENT_METHOD_ID.ONEPAY:
                            element.url = element.payUrl;
                            break;
                        case PAYMENT_METHOD_ID.STRIPE:
                            element.url = `${HOST_URL.API_URL}/redirect-payment-credit-card?sessionId=${element.payUrl}`
                            break;
                    }
                }
            });
        },

        //#region Processing payment url
        showDetailsTransaction(element) {
            this.$emit("processingEvent", {
                event: "showDetailsTransaction",
                data: element,
            });
        },
        //#endregion

        //#region Processing payment url
        showExportInvoice(element) {
            this.$emit("processingEvent", {
                event: "showExportInvoice",
                data: element,
            });
        }
        //#endregion
    }
}